import type { TeamPayload } from '@/store/types/TeamPayload'
import * as api from '@/backend/api'
import { errorMessages, isErrorResponse, parseError } from '@/backend/error'
import type { ApiResult } from '@/backend/darwin/types'

export const registerTeam = async (params: {
  name: string
  avatarHash: string | null
  invitationToken: string
}): Promise<ApiResult<TeamPayload>> => {
  try {
    const response = await api.post<TeamPayload>('teams', {
      name: params.name,
      hash: params.avatarHash,
      invitation_token: params.invitationToken,
    })
    return { data: response.data, ok: true }
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }
    return { ...parseError(error, errorMessages.TEAM_REGISTER), ok: false }
  }
}
